import React, { Component } from 'react';
import reqwest from 'reqwest';
import ReactTable from 'react-table';

import settings from '../../../../../../settings';
import ContentBox from '../../../../../components/FormArea/ContentBox';
import Button from '../../../../../components/Button';
import RightSide from '../../../../../components/FormArea/RightSide';
import Loader from '../../../../../components/Loader';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import getConstants from '../../../../../logic/constants';

class MarketingOverview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      marketingList: [],
      actionTypes: [],
      loading: true,
    };

    const marketingPromise = reqwest({
      method: 'get',
      url: settings.office.marketing.getList,
      data: {
        Token: localStorage.getItem('token'),
        OfficeGuid: this.props.OfficeGuid,
      },
    }).then(marketingResponse => {
      const marketingList = JSON.parse(marketingResponse);
      this.setState({
        marketingList,
      });
    });

    const marketingActionsPromise = getConstants('CentralMarketingActionTypes').then(actionTypes => {
      this.setState({
        actionTypes,
      });
    });

    Promise.all([marketingPromise, marketingActionsPromise]).then(() => {
      this.setState({
        loading: false,
      });
    });
  }

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    const data = this.state.marketingList.filter(row => row.Params.Guid);

    return (
      <>
        <div className='FormArea-Form-Left'>
          <ContentBox title='Marketingaktionen'>
            <ReactTable
              getTrProps={(_, { original }) => ({
                onClick: () => this.props.history.replace(`${this.props.match.url}/${original.Params.Guid}`),
              })}
              data={data}
              pageSize={data.length}
              noDataText='Es liegt keine Marketingaktion für das ausgewählte Büro vor.'
              defaultSorted={[
                {
                  id: 'Von',
                  desc: true,
                },
              ]}
              columns={[
                {
                  Header: 'Von',
                  accessor: 'Params.From',
                  maxWidth: 200,
                },
                {
                  Header: 'Bis',
                  accessor: 'Params.To',
                  maxWidth: 200,
                },
                {
                  Header: 'Aktion',
                  accessor: 'Params.Action',
                  Cell: ({ value }) => this.state.actionTypes.map(type => (type.value === value ? type.label : null)),
                },
              ]}
            />
          </ContentBox>
        </div>
        <RightSide>
          <Button big icon={faPlus} to={`${this.props.match.url}/new`} replace>
            Neues Marketing
          </Button>
        </RightSide>
      </>
    );
  }
}

export default MarketingOverview;
